<template>
  <l-rows>
    <a-title :text="$t('reporting.reports')" />
    <a-box>
      <o-form
        async
        :title="$t('reporting.downloadGamePerformanceReport')"
        :subtitle="$t('reporting.downloadGamePerformanceReportDescription')"
        :submit-text="$t('reporting.download')"
        :inputs="downloadGamePerformanceReportInputs"
        submit-disabled-reason=""
        @submit="downloadGamePerformanceReport"
      />
    </a-box>
    <a-box>
      <o-form
        async
        :title="$t('reporting.downloadAuditLog')"
        :subtitle="$t('reporting.downloadAuditLogDescription')"
        :submit-text="$t('reporting.download')"
        submit-disabled-reason=""
        @submit="downloadAuditLog"
      />
    </a-box>
    <a-box>
      <o-form
        async
        :title="$t('reporting.downloadCPVReport')"
        :subtitle="$t('reporting.downloadCPVReportDescription')"
        :submit-text="$t('reporting.download')"
        submit-disabled-reason=""
        @submit="downloadCPVReport"
      />
    </a-box>
    <a-box>
      <o-form
        async
        :title="$t('reporting.downloadFailedBookingsReport')"
        :subtitle="$t('reporting.downloadFailedBookingsReportDescription')"
        :submit-text="$t('reporting.download')"
        submit-disabled-reason=""
        @submit="downloadFailedBookingsReport"
      />
    </a-box>
    <a-box>
      <o-form
        async
        :title="$t('reporting.downloadSignificantEventsReport')"
        :subtitle="$t('reporting.downloadSignificantEventsReportDescription')"
        :submit-text="$t('reporting.download')"
        submit-disabled-reason=""
        @submit="downloadSignificantEventsReport"
      />
    </a-box>
    <a-box>
      <o-form
        async
        :title="$t('reporting.downloadGamePlayHistory')"
        :subtitle="$t('reporting.downloadGamePlayHistoryDescription')"
        :submit-text="$t('reporting.download')"
        submit-disabled-reason=""
        :inputs="downloadGamePlayHistoryInputs"
        @submit="downloadGamePlayHistory"
      />
    </a-box>
  </l-rows>
</template>

<script>
  import { ABox, ATitle, LRows, MInputDate, OForm } from 'codefabrik-gui-vue'
  import { CasinoSelect, GameSelect, CurrencySelect } from '@/components'
  import { reportingService } from '@/services'
  import { toast } from '@/shared'

  export default {
    name: 'ReportList',
    components: { LRows, ATitle, ABox, OForm },
    computed: {
      downloadGamePerformanceReportInputs () {
        return [
          {
            name: 'casinoId',
            is: CasinoSelect,
            properties: {
              placeholder: this.$t('common.all'),
              label: this.$t('common.casino'),
            },
            validators: 'required'
          },
          {
            name: 'gameId',
            is: GameSelect,
            properties: {
              fullwidth: true,
              label: this.$t('common.game'),
            },
            validators: 'required'
          },
          {
            name: 'currency',
            is: CurrencySelect,
            properties: {
              label: this.$t('common.currency'),
            },
          },
          {
            name: 'from',
            is: MInputDate,
            properties: {
              label: this.$t('common.start'),
            },
            validators: 'required'
          },
          {
            name: 'to',
            is: MInputDate,
            properties: {
              label: this.$t('common.end'),
            },
            validators: 'required'
          },
        ]
      },
      downloadGamePlayHistoryInputs () {
        return [
          {
            name: 'playerId',
            properties: {
              fullwidth: true,
              label: this.$t('common.playerId'),
            },
            validators: 'required'
          },
          {
            name: 'casinoId',
            is: CasinoSelect,
            properties: {
              fullwidth: true,
              placeholder: this.$t('common.all'),
              label: this.$t('common.casino'),
            },
            validators: 'required'
          },
          {
            name: 'currency',
            properties: {
              fullwidth: true,
              label: this.$t('common.currency'),
            },
            validators: 'required'
          },
          {
            name: 'gameId',
            is: GameSelect,
            properties: {
              fullwidth: true,
              label: this.$t('common.game'),
            },
            validators: 'required'
          },
        ]
      }
    },
    methods: {
      async displayError(response) {
        toast.showErrorToast(this.$t(await response.text()))
      },
      downloadGamePerformanceReport (data, resolve) {
        reportingService
          .downloadGamePerformanceReport(data)
          .catch(this.displayError)
          .finally(resolve)
      },
      downloadAuditLog (data, resolve) {
        reportingService
          .downloadAuditLog(data)
          .catch(this.displayError)
          .finally(resolve)
      },
      downloadCPVReport (data, resolve) {
        reportingService
          .downloadCPVReport(data)
          .catch(this.displayError)
          .finally(resolve)
      },
      downloadFailedBookingsReport (data, resolve) {
        reportingService
          .downloadFailedBookingsReport(data)
          .catch(this.displayError)
          .finally(resolve)
      },
      downloadSignificantEventsReport (data, resolve) {
        reportingService
          .downloadSignificantEventsReport(data)
          .catch(this.displayError)
          .finally(resolve)
      },
      downloadGamePlayHistory (data, resolve) {
        reportingService
          .downloadGamePlayHistory(data)
          .catch(this.displayError)
          .finally(resolve)
      }
    },
  }
</script>

<style scoped>

</style>
